// = Libs =
import { FC } from 'react';
import { IconProps } from '@/common/components/icons/icon.types';

// = Constants =
import COLORS from '@/constants/colors';

const TimerIcon: FC<IconProps> = ({ color = 'dark' }) => {
  const iconColor = COLORS[color];

  return (
    <svg viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M15.4677 8.38809V15.662L12.6982 20.5113M15.4667 27.2465C22.3518 27.2465 27.9333 21.8187 27.9333 15.1232C27.9333 8.42775 22.3518 3 15.4667 3C8.58152 3 3 8.42775 3 15.1232C3 21.8187 8.58152 27.2465 15.4667 27.2465Z"
        stroke={iconColor}
        strokeWidth="2.27556"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default TimerIcon;
